var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-wrapper"},[(_vm.isLoading || !_vm.destroyLoader)?_c('div',{staticClass:"loader-wrapper-container",class:{ 'is-show': _vm.isLoading }},[_c('Loader')],1):_vm._e(),(!_vm.isLoading)?_vm._t("default"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }